import { Resource } from "i18next";
import { queryKeyMatchesEntity } from "../../hooks/entityQueryKeys";
import React from "react";
import { useTranslation } from "react-i18next";
import useServerInfo from "../../hooks/useServerInfo";
import { useQueryClient } from "@tanstack/react-query";
import Entities from "../../Entities";

export function useChangeLanguage() {
  const { i18n } = useTranslation();

  const queryClient = useQueryClient();

  async function handleChangeLanguage(lang: string) {
    await i18n.changeLanguage(lang);
    document.documentElement.lang = lang;

    const promiseList = Object.values(Entities)
      .filter((i) => {
        return i.sendCulture;
      })
      .map((i) => {
        return queryClient
          .invalidateQueries({
            predicate: (query) => {
              return queryKeyMatchesEntity(query.queryKey, i.key);
            },
          })
          .then(() =>
            queryClient.invalidateQueries({
              predicate: (query) => {
                return queryKeyMatchesEntity(query.queryKey, i.keyDetail as string);
              },
            })
          );
      });

    await Promise.all(promiseList);
  }
  return handleChangeLanguage;
}

export default () => {
  const { i18n } = useTranslation();
  const o: Resource | undefined = i18n.options?.resources;

  const { data } = useServerInfo();

  const languages = data?.languages;

  const languageLabel = languages?.find((i) => i.id === i18n.language);

  const handleChangeLanguage = useChangeLanguage();

  function renderItems() {
    return (
      data !== undefined &&
      o !== undefined &&
      Object.keys(o).map((lang: string) => {
        const language = languages?.find((i) => i.id === lang);
        return {
          key: lang,
          className: "hover-primary",
          label: (
            <div key={lang} data-cy={"language-switcher-language-" + lang}>
              {language?.nativeName} | {language?.name}
            </div>
          ),
          onClick: () => {
            handleChangeLanguage(lang);
          },
        };
      })
    );
  }

  return {
    key: "language",
    className: "language-switcher",
    label: (
      <div className={"icon-wrapper-circle language-label hover-primary"} data-cy={"language-switcher"}>
        {languageLabel?.nativeName}
      </div>
    ),
    children: renderItems(),
  };
};
